// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"74":"f079128e","732":"21405f76","977":"9529ce89"}[chunkId] + ".chunk.js");